import appStore from 'stores/app'

export function buildFileUrl(path, domain = appStore.site.domain) {
  const url = new URL(`https://${domain}/${path || ''}`)

  if (process.env.NODE_ENV === 'development') {
    url.port = 3002
    url.protocol = 'http'
  }

  return url.toString()
}
